import { CheckBox } from '@mui/icons-material';
import { FormControlLabel } from '@mui/material';
import styled from 'styled-components';

const StyledFormControlLabel = styled(FormControlLabel)`
  width: 250px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 20px;
  margin-bottom: 5px;
  height: 20px;
`;

const StyledCheckBox = styled(CheckBox)`
  color: rgb(32, 144, 136);
`;

export { StyledFormControlLabel, StyledCheckBox };
